'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootReducer = undefined;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _app = require('./reducers/app');

var _app2 = _interopRequireDefault(_app);

var _conversation = require('./reducers/conversation');

var _conversation2 = _interopRequireDefault(_conversation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expirationTimeMillis = 1000 * 60 * 30; // 30 minute store expiry

var rootReducer = exports.rootReducer = (0, _redux.combineReducers)({
  app: _app2.default,
  conversation: _conversation2.default
});

var initialState = window && window.sessionStorage ? JSON.parse(window.sessionStorage.getItem('store')) || {} : {};

// Reset initial state if past expiry
if (window && window.sessionStorage) {
  var expires = Number(window.sessionStorage.getItem('store-expires'));
  var difference = Date.now() - expires;
  if (difference > expirationTimeMillis) {
    initialState = {};
  }
}

var persistMiddleware = function persistMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      var nextStateToPersist = store.getState();
      if (window && window.sessionStorage) {
        window.sessionStorage.setItem('store-expires', Date.now());
        window.sessionStorage.setItem('store', JSON.stringify(nextStateToPersist));
      }
      return result;
    };
  };
};

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var store = (0, _redux.createStore)(rootReducer, initialState, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, persistMiddleware)));

exports.default = store;